import _ from 'lodash';

import React, { PropTypes } from 'react';

import DropdownSelectGroup from './DropdownSelectGroup';
import { NitroHeading, NitroDivider, NitroPanel, NitroToggle, NitroRadioGroup, NitroRadio } from 'nitro-components';
import { FeatureList } from '../../components/accordions';

import styled from 'styled-components';
const ToggleWrapper = styled.div`
  float: right;
`;

const OthersHeading = styled(NitroHeading)`
  position: static;
`;

const RadioOption = ({ clickHandler, extra, filterData, selected, isLoading }) => {
  let selectedState;

  if(_.isEmpty(selected)) {
    selectedState = filterData[0];
  } else {
    selectedState = filterData.find((d) => {
      return d.key === selected.key
    });
  }
  const getSelectedOpt = (selOpt) => {
    return {
      termId: extra,
      key: selOpt.key,
      Value: selOpt.Value,
      componentType: 'ButtonSelectGroup'
    };
  }

  const selectedOption = getSelectedOpt(selectedState);

  const onToggle = (e, value) => {
    const selState = filterData.filter(x => x.key === value)[0];
    const newopt = getSelectedOpt(selState);
    if(clickHandler) clickHandler(newopt);
  }

  return (
    <section>
      <NitroHeading inline noMargin size="2" label={extra.replace(/([a-z](?=[A-Z]))/g, '$1 ')} />
      <ToggleWrapper>
        <NitroRadioGroup
            name={extra}
            defaultSelected={selectedState.key}
            action={onToggle}
            disabled={isLoading}
            >
            {filterData.map((item, index) => {
              return (
                <NitroRadio key={index} value={item.key} label={item.Value} style={{padding: '4px 0'}} disabled={isLoading}/>
              );
            })}
        </NitroRadioGroup>
      </ToggleWrapper>
      <NitroDivider />
    </section>
  );
};
RadioOption.propTypes = {
  clickHandler: PropTypes.func,
  extra: PropTypes.string,
  filterData: PropTypes.array,
  selected: PropTypes.object,
  isLoading: PropTypes.bool
};

const LeaseDetails = ({ vehicle, stateCache, clickHandler, isLoading }) => {
  // const terms = vehicle.TermDistance.map((v,i) => {
  //   let distance = parseInt(v.Distance, 10);
  //   distance = distance.toLocaleString("en-US");
  //   return {key: i, Value: `${v.Term} months - ${distance}km`};
  // });

  const extras = [
    'ReliefVehicle',
    'Roadside',
    'AccidentManagement',
    'Insurance',
    'TollService',
    'FuelCard',
    'TyresIncluded'
  ];

  // e.g. only one choice come back and is preselected
  let oneChoiceSelectable = [];

  const extraGroups = extras.map(extra => {
    const item = vehicle[extra];
    const data = item.map((v, i) => {
      return { key: v.Key, Value: v.Value, IsSelected: v.IsSelected };
    });

    const filterData = data;
    let selectedData = filterData[0];
    if(filterData.length > 1) {
      selectedData = filterData.filter(d => d.IsSelected === true)[0];
      selectedData = (selectedData)? selectedData: filterData[0]; // set default value
    }

    let selectedState;

    // persist select status from cache or from api
    if (stateCache[extra]) {
      selectedState = { key: stateCache[extra].key };
    } else if (selectedData) {
      selectedState = { key: selectedData.key };
    }

    if (filterData.length === 0) {
      return null;
    } else if (filterData.length === 1) {
      oneChoiceSelectable.push({ ...selectedData, extra: extra.replace(/([a-z](?=[A-Z]))/g, '$1 ') });
    } else {
      return (
        <DropdownSelectGroup
          key={extra}
          termId={extra}
          label={extra.replace(/([a-z](?=[A-Z]))/g, '$1 ')}
          data={filterData}
          selected={{ ...selectedState }}
          disabled={isLoading}
          clickHandler={selectedOption => clickHandler && clickHandler(selectedOption)}
        />
      );
    }
    return null;
  }).filter(v => v);

  const otherFeatures = oneChoiceSelectable.length > 0
    ? <section>
        <OthersHeading size="2" align="left" label="Other included features" />
        <FeatureList list={oneChoiceSelectable.map(({ extra, Value }) => `${extra} : ${Value}`)} />
      </section>
    : null;

  // If no extras, don't render the section
  if ((!extraGroups || !extraGroups.length) && !otherFeatures) {
    return null;
  }

  return (
    <NitroPanel>

      {extraGroups}

      {otherFeatures}

    </NitroPanel>
  );
};

LeaseDetails.propTypes = {
  vehicle: PropTypes.object,
  clickHandler: PropTypes.func,
  stateCache: PropTypes.object,
  isLoading: PropTypes.bool
};

export default LeaseDetails;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/components/LeaseDetails.js